<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOpen]="true"
  [cdkConnectedOverlayOrigin]="body"
  [cdkConnectedOverlayHasBackdrop]="hasBackdropSg()"
  [cdkConnectedOverlayBackdropClass]="backdropClassSg()"
  [cdkConnectedOverlayPositionStrategy]="overlayPositionSg()"
  (overlayOutsideClick)="backdropClicked.emit($event)"
  (backdropClick)="backdropClicked.emit($event)"
>
  <div
    class="slideout-overlay"
    [style.height]="slideoutOverlayHeightSg()"
    data-test-id="slideout"
  >
    <div class="slideout-overlay__header">
      <div class="slideout-overlay__header-title">{{ nameSg() }}</div>
      <div class="slideout-overlay__header-actions">
        <ng-content select="[actions]"></ng-content>
      </div>
    </div>
    <div class="slideout-overlay__body">
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
